import {
  type PackagesAutocompleteResult,
  PackageType,
} from "@b2bportal/core-packages";

import type { CallState, WithOptionalProps } from "@b2bportal/core-types";
import type { DateRange, Travelers } from "@b2bportal/packages-api";

/**
 * Complete package search parameters
 */
export interface PackagesSearch {
  origin: PackagesAutocompleteResult;
  destination: PackagesAutocompleteResult;
  dateRange: DateRange;
  guests: Travelers;
  packageType?: PackageType;
  driverAge?: number;
  roomCount: number;
}

/**
 * Package search form values (with optional fields)
 */
export interface NewPackagesSearch {
  origin?: PackagesAutocompleteResult;
  destination?: PackagesAutocompleteResult;
  dateRange: WithOptionalProps<DateRange, "from" | "until">;
  guests: Travelers;
  roomCount: number;
  packageType?: PackageType;
  driverAge?: number;
}

/**
 * Package search state shape
 */
export interface PackageSearchState {
  searchFormValues: NewPackagesSearch;
  requestedSearch?: PackagesSearch;
  search?: PackagesSearch;
  initialized?: CallState;
  /** True while initializePackages is in flight. Used to gate fetchPackageSearchParams
   *  from flipping initialized to Success/Failed mid-init when invoked as a sub-thunk. */
  isInitializingPackages?: boolean;
}

/**
 * Initial state for package search
 */
export const initialSearchState: PackageSearchState = {
  searchFormValues: {
    packageType: PackageType.HOTEL_FLIGHT_CAR,
    dateRange: {},
    guests: {
      adultCount: 2,
      childAges: [],
      infantOnLapAges: [],
      infantInSeatAges: [],
    },
    driverAge: 25,
    roomCount: 1,
  },
};
